export const config = {
  title:
    'Level up your business by\nincorporating unique\nsoftware solutions\ndeveloped by Modsen',
  buttonText: 'Get started',
}
